export const MAX_COL_WIDTH = 180;
